<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button></ion-back-button>
            </ion-buttons>
            <ion-title>Crea una frequenza per le ispezioni</ion-title>

            <ion-buttons slot="end">
                <ion-button :disabled="isInterventionStoreLoading && !formValid" :strong="true" @click="onSubmit()">Salva
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="--background: var(--ion-item-background)">
        <ion-header>
            <h1 class=" font-bold">
                Aggiungi una frequenza per le ispezioni
            </h1>
        </ion-header>
        <form class="">
            <form-input v-model="description" :rules="[Validation.required]"
                        label="Denominazione"></form-input>
            <form-input v-model="yearInterventionsAmount" :type="FormInputType.number" :rules="[Validation.required]"
                        label="Numero di interventi annuali"></form-input>
            <h5 style="font-weight: bold">Estremi di definizione dello stato di scadenza</h5>
            <ion-item style="--inner-padding-bottom: 8px">
                <form-input slot="start"
                            v-model="recentInspectionInterval" :type="FormInputType.number"
                            :rules="[Validation.required]"
                            style="max-width: 3rem; border-radius: 8px; text-align: center"></form-input>
                <div style="padding-right: 8px">
                    Numero di giorni per l'intervallo relativo allo stato "Ultima ispezione recente"
                </div>
                <div class="expiration-state-indicator recent_inspection" slot="end"></div>
            </ion-item>
            <ion-item class="ion-margin-top" style="--inner-padding-bottom: 8px">
                <form-input slot="start"
                            v-model="regularSituationInterval" :type="FormInputType.number"
                            :rules="[Validation.required]"
                            style="max-width: 3rem; border-radius: 8px; text-align: center"></form-input>
                <div style="padding-right: 8px">
                    Numero di giorni per l'intervallo relativo allo stato "Situazione regolare"
                </div>
                <div class="expiration-state-indicator regular_situation" slot="end"></div>
            </ion-item>

            <ion-item class="ion-margin-top" style="--inner-padding-bottom: 8px">
                <form-input slot="start"
                            v-model="expiringSituationInterval" :type="FormInputType.number"
                            :rules="[Validation.required]"
                            style="max-width: 3rem; border-radius: 8px; text-align: center"></form-input>
                <div style="padding-right: 8px">
                    Numero di giorni per l'intervallo relativo allo stato "Situazione in scadenza"
                </div>
                <div class="expiration-state-indicator expiring_situation" slot="end"></div>
            </ion-item>
            <ion-item class="ion-margin-top" lines="none">
                <ion-note>
                    In seguito al {{ expiringSituationInterval }} giorno, la situazione delle ispezioni è da
                    considerazrsi scaduta
                </ion-note>
                <div class="expiration-state-indicator expired_situation" slot="end"></div>
            </ion-item>

        </form>
    </ion-content>
</template>

<script setup lang="ts">
import {
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar
} from "@ionic/vue";
import {computed, inject, PropType, ref} from "vue";
import {useInterventionFrequencyStore} from "@/stores/interventionFrequencies";
import {Validation} from "@/utility";
import FormInput from "@/components/FormInput.vue";
import {FormInputType} from "@/types/inputType";

const props = defineProps({
    interventionFrequencyID: {
        type: Number,
        required: false,
    },
})

const navController = inject('navController')
const interventionStore = useInterventionFrequencyStore()
const interventionFrequency = props.interventionFrequencyID ? interventionStore.getInterventionFrequencyById(props.interventionFrequencyID!) : undefined;
const interventionFrequencyID = interventionFrequency?.id;
const description = ref<string | undefined>(interventionFrequency?.description);
const yearInterventionsAmount = ref<number | undefined>(interventionFrequency?.year_interventions_amount);
const recentInspectionInterval = ref<number | undefined>(interventionFrequency?.recent_inspection_interval);
const regularSituationInterval = ref<number | undefined>(interventionFrequency?.regular_situation_interval);
const expiringSituationInterval = ref<number | undefined>(interventionFrequency?.expiring_situation_interval);
const formValid = computed(() => Boolean(description.value) && Boolean(yearInterventionsAmount.value) && Boolean(recentInspectionInterval.value) && Boolean(regularSituationInterval.value) && Boolean(expiringSituationInterval.value));

const isInterventionStoreLoading = computed(() => interventionStore.isLoading);
const onSubmit = () => {
    interventionStore.pushInspectionFrequencies({
        id: interventionFrequencyID,
        description: description.value!,
        year_interventions_amount: yearInterventionsAmount.value!,
        recent_inspection_interval: recentInspectionInterval.value!,
        regular_situation_interval: regularSituationInterval.value!,
        expiring_situation_interval: expiringSituationInterval.value!,
    })
    // @ts-ignore
    navController.value.$el.pop()
}
</script>

<style scoped lang="scss">
.expiration-state-indicator {
    height: 1rem;
    width: 1rem;
    border-radius: 1rem;

    &.recent_inspection {
        background-color: lightskyblue;
    }

    &.regular_situation {
        background-color: green;
    }

    &.expiring_situation {
        background-color: yellow;
        color: var(--ion-background-color);
    }

    &.expired_situation {
        background-color: red;
        color: var(--ion-background-color);
    }
}


</style>
